var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _vm.isLoading
        ? _c("pui-loader-spinner", {
            staticStyle: {
              position: "absolute",
              top: "0",
              right: "0",
              "z-index": "999",
            },
            attrs: { title: `${_vm.$t("eventSubmittingModal.text")}...` },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "chart-wrapper", staticStyle: { "max-width": "100%" } },
        [
          _c("div", {
            ref: "myChart",
            staticClass: "chart",
            staticStyle: { "box-shadow": "0 1px 8px 0 rgb(0 0 0 / 16%)" },
            attrs: { option: _vm.option },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }